import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["type", "onPageChange", "currentPage"];
import { forwardRef } from 'react';
import Alternative from "./variants/Alternative";
import Banner from "./variants/Banner";
import Carousel from "./variants/Carousel";
import CarouselS from "./variants/CarouselS";
import Default from "./variants/Default";
import DefaultS from "./variants/DefaultS";
import Dots from "./variants/Dots";
import { jsx as _jsx } from "react/jsx-runtime";
var PaginationVariants = {
  'default-s': DefaultS,
  carousel: Carousel,
  'carousel-s': CarouselS,
  banner: Banner
};
var Pagination = function Pagination(_ref, ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'default' : _ref$type,
    onPageChange = _ref.onPageChange,
    _ref$currentPage = _ref.currentPage,
    currentPage = _ref$currentPage === void 0 ? 1 : _ref$currentPage,
    paginationProps = _objectWithoutProperties(_ref, _excluded);
  var onPrev = function onPrev() {
    if (typeof onPageChange === 'function') {
      onPageChange(currentPage - 1);
    }
  };
  var onNext = function onNext() {
    if (typeof onPageChange === 'function') {
      onPageChange(currentPage + 1);
    }
  };
  var props = _objectSpread({
    ref: ref,
    onPrev: onPrev,
    onNext: onNext,
    currentPage: currentPage
  }, paginationProps);
  if (type === 'default') {
    // @ts-ignore
    return /*#__PURE__*/_jsx(Default, _objectSpread({
      onPageChange: onPageChange
    }, props));
  }
  if (type === 'alternative') {
    // @ts-ignore
    return /*#__PURE__*/_jsx(Alternative, _objectSpread({
      onPageChange: onPageChange
    }, props));
  }
  if (type === 'dots') {
    // @ts-ignore
    return /*#__PURE__*/_jsx(Dots, _objectSpread({
      onPageChange: onPageChange
    }, props));
  }
  var PaginationComponent = PaginationVariants[type];

  // @ts-ignore
  return /*#__PURE__*/_jsx(PaginationComponent, _objectSpread({}, props));
};
export default /*#__PURE__*/forwardRef(Pagination);